module.exports = __webpack_public_path__ + "static/media/tips3@2x.f2d37102.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/tips3@2x.png
// module id = 1247
// module chunks = 0